import { BlogLayout } from '../pages/blog/BlogLayout';
import { BlogListPage } from '../pages/blog/BlogListPage';
import { BlogPostPage } from '../pages/blog/BlogPostPage';
import { BlogNotFoundPage } from '../pages/blog/BlogNotFoundPage';
import { SitemapPage } from '../pages/blog/SitemapPage';
import { blogListLoader, blogPostLoader } from './blog-loaders';

// Used by entry-server.tsx createStaticHandler AND by routes.tsx for
// client-side navigation after hydration.
export const blogRoutes = [
  {
    path: '/blog',
    element: <BlogLayout />,
    children: [
      {
        id: 'blog-list',
        index: true,
        element: <BlogListPage />,
        loader: blogListLoader,
      },
      // Sitemap must be BEFORE :slug to match first
      { path: 'sitemap', element: <SitemapPage /> },
      {
        id: 'blog-category',
        path: 'category/:categorySlug',
        element: <BlogListPage />,
        loader: blogListLoader,
      },
      {
        id: 'blog-post',
        path: ':slug',
        element: <BlogPostPage />,
        loader: blogPostLoader,
      },
      {
        path: '*',
        element: <BlogNotFoundPage />,
      },
    ],
  },
];
